/* eslint-disable no-return-assign */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import parse from 'react-html-parser';

import { urlMassiveTemplateExcel } from '../../../../../constants';

import Modal from '../../../../../components/modal';
import Input from '../../../../../components/input';
import Typography from '../../../../../components/typography';
import ContentSection from '../../../../../components/contentSection';
import StepProgressBar from '../../../../../components/stepProgressBar';
import { ReactComponent as ArrowBack } from '../../../../../assets/images/icon-arrow-back-color-primary.svg';

import Add from '../../../../../assets/images/uploadIcon.png';
import stepOneIcon from '../../../../../assets/images/stepOne.png';
import stepTwoIcon from '../../../../../assets/images/stepTwo.png';
import stepThreeIcon from '../../../../../assets/images/stepThree.png';

import './stepOne.scss';
import ModalLoading from '../loadingModal';

const text = parse('<span>Aprende <strong style="color:#009AF0; cursor:pointer">aquí</strong> como utilizarla</span>');
const downloadXlsx = parse('<span>Descarga la plantilla <strong style="color:#009AF0; cursor:pointer">aquí</strong></span>');
const linkYoutube = 'https://www.youtube.com/watch?v=mYfA2K8KO5Y&t=1s';

const StepOneQuoteMultipleShippings = ({
  next, isMobileDevice, history, file, setFile, fileName, setFileName,
  readExcelLoading, currentStep, step, showModal, progress,
}) => {
  useEffect(() => {
    if (file) {
      next();
    }
  }, [file]);
  return (
    <ContentSection className="container-stepOne-quoteMultipleShippings">
      <div className="progressBar">
        <StepProgressBar
          steps={[{}, {}, {}, {}].map((item, index) => {
            const newItem = item;
            if (index < step) newItem.success = true;
            return newItem;
          })}
          currentStep={currentStep}
        />
      </div>
      <div
        id="multiple-shippings__template"
        className={isMobileDevice ? 'mobile-mode' : 'desktop-mode'}
      >
        <div className="content-top">
          <div className={isMobileDevice ? 'adjust-arrow' : null}>
            <ArrowBack
              className={isMobileDevice ? 'arrow' : 'arrow-hidden'}
              onClick={() => history.goBack()}
            />
            {isMobileDevice && (
            <Typography text="Cotización Masiva" type="superTitle-italic" />
            )}
          </div>
          <div className="left-content">
            <div>
              <img src={stepOneIcon} alt="step1" />
              <Typography
                text={downloadXlsx}
                type="paragraph"
                className=""
                onClick={() => {
                  window.open(urlMassiveTemplateExcel, '_blank', 'noopener');
                }}
              />
            </div>
            <div>
              <img src={stepTwoIcon} alt="step2" />
              <Typography
                text="Diligencia la plantilla con la información de tus envíos"
                type="paragraph"
              />
            </div>
          </div>
          <div className="right-content">
            <div className="uploadInput">
              <img src={stepThreeIcon} alt="step3" className="icon-3" />
              <Input
                value={fileName || 'Carga el archivo'}
                onChange={(target) => {
                  const selectedFile = target.files[0];
                  if (!selectedFile) return;
                  setFile(selectedFile);
                  setFileName(selectedFile.name);
                  next();
                }}
                type="file"
                iconRigth={Add}
                loading={readExcelLoading}
                typeHidden
                lineHidden
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
            application/vnd.ms-excel"
              />
            </div>
          </div>
        </div>
        <Typography
          text={text}
          type="paragraph"
          className=""
          onClick={() => {
            window.open(linkYoutube, '_blank', 'noopener');
          }}
        />
      </div>
      {showModal && (
        <Modal>
          <ModalLoading
            show={showModal}
            progress={progress}
            text="Espera mientras validamos las direcciones"
          />
        </Modal>
      )}
    </ContentSection>
  );
};

StepOneQuoteMultipleShippings.propTypes = {
  next: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  file: PropTypes.any,
  setFile: PropTypes.func.isRequired,
  fileName: PropTypes.string,
  setFileName: PropTypes.func.isRequired,
  readExcelLoading: PropTypes.bool.isRequired,
  currentStep: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  showModal: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
};

StepOneQuoteMultipleShippings.defaultProps = {
  file: null,
  fileName: null,
};

export default StepOneQuoteMultipleShippings;
